/**
 * Collection of all the Canadian provinces and territories.
 */
export const PROVINCES = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NS: 'Nova Scotia',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon',
} as const
Object.freeze(PROVINCES)
export type PROVINCES_CODE = keyof typeof PROVINCES
export type PROVINCES = (typeof PROVINCES)[PROVINCES_CODE]

/**
 * Collection of all the Canadian provinces in French.
 */
export const PROVINCES_FRENCH = {
  'Colombie-Britannique': PROVINCES.BC,
  'Nouveau-Brunswick': PROVINCES.NB,
  'Nouvelle-Écosse': PROVINCES.NS,
  'Terre-Neuve-et-Labrador': PROVINCES.NL,
  'Île-du-Prince-Édouard': PROVINCES.PE,
  'Québec': PROVINCES.QC,
  'Territoires du Nord-Ouest': PROVINCES.NT,
} as const
Object.freeze(PROVINCES_FRENCH)
export type PROVINCES_FRENCH_CODE = keyof typeof PROVINCES_FRENCH
export type PROVINCES_FRENCH = (typeof PROVINCES_FRENCH)[PROVINCES_FRENCH_CODE]

/**
 * Collection of all the American states.
 */
export const STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
} as const
Object.freeze(STATES)
export type STATES_CODE = keyof typeof STATES
export type STATES = (typeof STATES)[STATES_CODE]

/**
 * Collection of all the Canadian provinces and territories and American states.
 */
export const REGIONS = { ...PROVINCES, ...STATES } as const
Object.freeze(REGIONS)
export type REGIONS_CODE = keyof typeof REGIONS
export type REGIONS = (typeof REGIONS)[keyof typeof REGIONS]
